<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
<!--        <div v-if="$gate.isBranchManager()">-->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
        <br>
        <div class="col-lg-12">
            <div class="card card-danger card-outline collapsed-card">
                <div class="card-header">
                    <div class="card-title">Data Filters</div>
                    <div class="card-tools">
                        <!-- Collapse Button -->
                        <button type="button" class="btn btn-tool btn-danger" data-card-widget="collapse"><i class="fas fa-minus"></i> Show/Hide</button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="col-lg-12 float-left">
                        <div class="row">

                            <div class="col-sm-4">
                                <div class="form-group">
                                    <span class="right badge badge-secondary">To Branch:</span>
                                    <select class="form-control" v-model="params.from_branch">
                                        <option v-for="branch in branches" :value="branch.branch_code">{{branch.branch}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <span class="right badge badge-secondary">Status:</span>
                                    <select class="form-control" v-model="params.status">
                                        <option value="Pending Zonal Manager Approval">Pending Zonal Manager Approval</option>
                                        <option value="Zonal Manager Approved">Zonal Manager Approved</option>
                                        <option value="Pending Branch Manager Approval">Pending Branch Manager Approval</option>
                                        <option value="Branch Manager Approved">Branch Manager Approved</option>
                                        <option value="In Transit">In Transit</option>
                                        <option value="Received At Requested Branch">Received At Requested Branch</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <span class="right badge badge-secondary">Created |From Date:</span>
                                    <input type="date" class="form-control" v-model="params.from_date" placeholder="From date">
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <span class="right badge badge-secondary">Created |To Date:</span>
                                    <input type="date" class="form-control" v-model="params.to_date" placeholder="To date">
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <span class="right badge badge-secondary">SAP Doc Number:</span>
                                    <input class="form-control" placeholder="Enter SAP Doc Number" v-model="params.sapdoc" type="text">
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <span class="right badge badge-secondary">ST ID:</span>
                                    <input class="form-control" placeholder="Enter stock transfer no." v-model="params.st_id" type="number" min="1">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <button class="btn btn-primary" style="width:100% !important;" @click="getRequests('/api/getBranchOutwardTransferRequests')">Search</button>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <button class="btn btn-danger" style="width:100% !important;" @click="reset">Reset</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
			<br>
			<div class="col-md-12">
				<div class="card card-primay card-outline">
					<div class="card-body">
						<table class="table table-hover table-striped table-bordered">
							<thead>
								<tr>
                                    <th scope="col">ST_ID</th>
                                    <th scope="col">Date</th>
									<th scope="col">From Branch/Warehouse</th>
									<th scope="col">Intermediate Branch/Warehouse</th>
									<th scope="col">Destination Branch/Warehouse</th>
									<th scope="col">Requested By</th>
									<th scope="col">Status</th>
									<th scope="col">Manage</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="j in requests">
                                    <td>{{j.id}}</td>
                                    <td>{{j.created_at | smallDate}}</td>
									<td>{{j.source_branch}}/{{j.source_warehouse}}</td>
									<td>{{j.intermediate_branch}}/{{j.intermediate_warehouse}}</td>
									<td>{{j.destination_branch}}/{{j.destination_warehouse}}</td>
									<td>{{j.user.user_detail}}</td>
									<td>{{j.status}}</td>
									<td>
<!--										<button class="btn btn-primary">View</button>-->
                                        <button v-if="j.status=='Received At Requested Branch'" class="btn btn-success" @click="editRequest(j.id)">Completed</button>
                                        <button v-if="j.status!='Received At Requested Branch'" class="btn btn-warning" @click="editRequest(j.id)">Edit</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="card-footer">
						<pagination :pagination="pagination"
						 	@prev="getRequests(pagination.prevPageUrl)"
						  @next="getRequests(pagination.nextPageUrl)"
						></pagination>
					</div>
				</div>
			</div>

    </section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
<!--        </div>-->
<!--        <div v-if="!$gate.isBranchManager()">-->
<!--             <access-denied></access-denied>-->
<!--        </div>-->
    </div>
</template>

<script>
		import Pagination from '../../pagination.vue';
    export default {
        mounted() {
            console.log('Component mounted.')
        },

        components: {pagination: Pagination},

        created(){
            this.getBranches();
        	this.getRequests();
        },

        data(){
        	return {
        		requests: [],
                branches:[],
                params: new Form({
                    from_branch: null,
                    to_branch: null,
                    sapdoc: null,
                    from_date: null,
                    to_date: null,
                    source: null,
                    st_id: null,
                    status: null
                }),
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
                    results:'',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		}
        	}
        },

        methods: {
        	getRequests(url="/api/getBranchOutwardTransferRequests"){
                axios.post(url,{results: this.results, params: this.params})
                    .then(response => {
                        this.requests = response.data.data.data;
                        this.configPagination(response.data.data);
                    });
            },

            reset(){
                this.params.reset();
                this.getRequests();
            },

            getBranches(){
                if(this.usertype == 'zonal-manager'){
                    axios.post("/api/getZonalManagerBranches")
                        .then(response => {
                            this.branches = response.data;
                        });
                }
                else{
                    axios.post("/api/getSAPBranches")
                        .then(response => {
                            this.branches = response.data;
                        })
                }
            },

        	configPagination(data){
      			this.pagination.lastPage=data.lastPage;
         		this.pagination.currentPage=data.current_page;
    	  		this.pagination.total=data.total;
        		this.pagination.lastPageUrl=data.last_page_url;
       			this.pagination.nextPageUrl=data.next_page_url;
       			this.pagination.prevPageUrl=data.prev_page_url;
     		 		this.pagination.from=data.from;
        		this.pagination.to=data.to;
    			},

    			editRequest(id){
    				// this.$router.push('/stock-transfer-details/'+id);
                    let route = this.$router.resolve('/stock-transfer-details/'+id);
                    window.open(route.href, '_blank');
    			}
        }
    }
</script>
